export const fixedPortalNavigation = {
  code: 'PORTAL_MY',
  label: '我的',
  modules: [
    {
      key: 'portal-workbench-pages',
      title: '工作台',
      leaves: [
        { code: 'PORTAL_WORKBENCH', label: '工作台', path: '/portal/workbench' },
        { code: 'PORTAL_OPERATIONS', label: '操作列表', path: '/portal/operations' },
      ],
    },
    {
      key: 'portal-task-pages',
      title: '任务中心',
      leaves: [
        { code: 'PORTAL_TODOS', label: '我的任务', path: '/portal/todos' },
        { code: 'PORTAL_DRAFTS', label: '草稿箱', path: '/portal/drafts' },
      ],
    },
    {
      key: 'portal-personal-settings',
      title: '个人中心',
      leaves: [
        { code: 'PORTAL_PERSONAL', label: '个人中心', path: '/portal/personal' },
      ],
    },
  ],
} as const;

export const fixedPortalLeaves = fixedPortalNavigation.modules.flatMap(module =>
  module.leaves.map(leaf => ({ ...leaf, moduleKey: module.key, moduleTitle: module.title })));

export const defaultPortalPath = fixedPortalLeaves[0].path;

export type FeishuEntry = { appId?: string; invalid: boolean };

export function readFeishuEntry(search: string): FeishuEntry {
  const values = new URLSearchParams(search).getAll('feishuAppId');
  if (values.length === 0) return { invalid: false };
  if (values.length !== 1 || values[0]!.length < 1 || values[0]!.length > 128) {
    return { invalid: true };
  }
  return { appId: values[0], invalid: false };
}

export function withFeishuEntry(path: string, appId?: string): string {
  if (!appId) return path;
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}feishuAppId=${encodeURIComponent(appId)}`;
}

export function normalizePortalPath(pathname: string) {
  const value = pathname.replace(/\/{2,}/g, '/').replace(/\/$/, '');
  return value || defaultPortalPath;
}

export function isFixedPortalPath(pathname: string) {
  return fixedPortalLeaves.some(item => item.path === pathname
    || (item.path === '/portal/todos' && pathname.startsWith('/portal/todos/'))
    || (item.path === '/portal/drafts' && pathname.startsWith('/portal/drafts/'))
    || (item.path === '/portal/operations'
      && pathname.startsWith('/portal/operations/')));
}

export function resolveFixedPortalLeaf(pathname: string) {
  return fixedPortalLeaves.find(item => item.path === pathname
    || (item.path === '/portal/todos' && pathname.startsWith('/portal/todos/'))
    || (item.path === '/portal/drafts' && pathname.startsWith('/portal/drafts/'))
    || (item.path === '/portal/operations'
      && pathname.startsWith('/portal/operations/')));
}

export function parsePortalOperationPath(pathname: string) {
  const match = /^\/portal\/operations\/([A-Z][A-Z0-9_]{1,159})\/([A-Z][A-Z0-9_]{1,159})$/
    .exec(pathname);
  return match
    ? {
      applicationCode: match[1]!,
      operationCode: match[2]!,
    }
    : undefined;
}

export function isPortalApplicationPath(pathname: string) {
  return pathname === '/portal/apps' || pathname.startsWith('/portal/apps/');
}
